import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LazyLoadEvent } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { SeguridadService } from './seguridad.service';
import { lastValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { Global } from '../../global';
import { GrupoAccesoRegistro } from '../models/seguridad/grupo_acceso.model';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

    seguridadService = new SeguridadService();

    /** objeto que selecionado */
    obj: Record<string, any>;

    dtPrefix = Global.PREFIX_RECORD;
    /**
     * nombre de la tabla en la base de datos
     */
    recordName!: string;
    /**
     * codigo del registro
     */
    codigoRegistro!: string;
    /**
     * codigo del modulo
     */
    
    codigoModulo: string;
    /**
     * Url correspondiente al servicio a consultar.
     */
    url!: string;
    /**
     * Cuerpo de la consulta a ser realizada.
     */
    body: any = {};
    /**
     * Usar filtro tipo de aceso
    */
    controlarTipoAcceso: boolean = true;
    /** 
     * variable para enviar filtros en caso de que se necesiten
     * formato de ejempo { field: 'nombre_campo', type: 'tipo_de_dato', value: 'valor_del_campo' }
    */
    otherAdittionalFilters: Record<string, any>[] = []

    header: Record<string, any> = {
        api_username: environment.API_USERNAME,
        api_password: environment.API_PASSWORD,
        "x-token": this.seguridadService.getToken(),
        web: 'true',
        version: environment.VERSION
    };

    constructor( public http: HttpClient ) { }

    async updateToken() {
        const token = this.seguridadService.getToken();
        this.header['x-token'] = token;
    }

    async get(id: number): Promise<ServiceResponse> {
        try {            
            await this.updateToken();
            this.header['filters'] = JSON.stringify(await this.getAdicionalFilters( true ));
            let url = `${this.url}/${id}`;
            const resp = await lastValueFrom( this.http.get<any>(url, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            console.log(error);            
            return this.checkError( error );
        }
    }

     async getAll( size?: number, otherFilters?: Record<string, any> ): Promise<ServiceResponse> {
        try {
            await this.updateToken();
            const params = await this.getParams();            
            const filters = await this.getFilters();
            
            if ( otherFilters ) {
                // filters.globalFilter = null;
                // filters.multiSortMeta = otherFilters.multiSortMeta;
                filters.filters = JSON.stringify(otherFilters.filters)
            }
            if ( size ) { params.size = size };
            
            this.header['filters'] = JSON.stringify(filters);

            const resp = await lastValueFrom( this.http.get<any>(this.url, { headers: this.header, params }) );
            return resp;
        } catch (error: any) {
            console.log(error);            
            return this.checkError( error );
        }
    }

    async post(body: any): Promise<ServiceResponse> {
        try {
            await this.updateToken();
            this.header['filters'] = JSON.stringify(await this.getAdicionalFilters());
            this.body = body;
            delete this.body.id;
            let url = `${this.url}`;
            const resp = await lastValueFrom( this.http.post<any>(`${url}`, this.body, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async postAll(body: any): Promise<ServiceResponse> {
        try {
            await this.updateToken();
            this.header['filters'] = JSON.stringify(await this.getAdicionalFilters());
            this.body = body;
            let url = `${this.url}/create/bulk`;
            const resp = await lastValueFrom( this.http.post<any>(`${url}`, this.body, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }
    
    async put(id: number, body: any): Promise<ServiceResponse> {
        try {
            await this.updateToken();
            this.header['filters'] = JSON.stringify(await this.getAdicionalFilters( true ));
            this.body = body;
            delete this.body.id;
            let url = `${this.url}/${id}`;
            const resp = await lastValueFrom( this.http.put<ServiceResponse>(url, this.body, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }

    async delete(id: number): Promise<ServiceResponse> {
        try {
            await this.updateToken();
            this.header['filters'] = JSON.stringify(await this.getAdicionalFilters( true) );
            let url = `${this.url}/${id}`;
            const resp = await lastValueFrom( this.http.delete<ServiceResponse>(url, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            return this.checkError( error );
        }
    }


    async getParams(): Promise<Record<string, any>> {
        const dt = sessionStorage.getItem(`${this.dtPrefix}.${this.recordName}`)
        if ( dt ) {
            const dtJson = JSON.parse(dt!) as LazyLoadEvent;
            let { rows, first } = dtJson;
            if ( !rows ) { rows = 10 };
            let page = 0;
            if ( first !== 0 ) { page = Math.ceil(first!/rows!)}
            return { page, size: rows }
        }
        return { page: 0, size: 10 }
    }

    async getFilters(): Promise<Record<string, any>> {
        const dt = sessionStorage.getItem(`${this.dtPrefix}.${this.recordName}1`)
        const dtJson = JSON.parse(dt!) as LazyLoadEvent;
        const multiSortMeta = dtJson?.multiSortMeta ? dtJson.multiSortMeta : [];
        const globalFilter = dtJson?.globalFilter;
        const fields = sessionStorage.getItem(`${this.dtPrefix}.${this.recordName}_fields`)
        const filters = fields
        const aditionalFilters = JSON.stringify(await this.getAdicionalFilters());
        const groupBy = [];
        return { filters, aditionalFilters, multiSortMeta, globalFilter, groupBy }
    }

    async getAdicionalFilters( filtrarEmpresa?: boolean ): Promise<Record<string, any>[]> {
        const currentUser = this.seguridadService.getCurrentUser(); 
        let filtros = [];        
        if ( !currentUser.superusuario ) {
            filtros = [{ field: "id_empresa", type: "id", value: currentUser?.id_empresa }];
            
            // const sucursales = await this.seguridadService.getSucursales( currentUser?.grupo_acceso, this.codigoModulo, this.codigoRegistro );
        } else if ( filtrarEmpresa ) {
            filtros = [{ field: "id_empresa", type: "id", value: this.obj.id_empresa }];
        }
        if ( this.controlarTipoAcceso ) {
            const respAcceso = await this.seguridadService.tipoAcceso(this.codigoModulo, this.codigoRegistro);
            if ( respAcceso === GrupoAccesoRegistro.ACCESO_USUARIO ) {
                filtros.push({ field: "id_creado_por", type: "id", value: currentUser?.id });
            }
        }
        filtros.push(...this.otherAdittionalFilters);
        // console.log(sucursales);
        return filtros;
    }
    
    async leerArchivo(file: any ) {
        return new Promise( (resolve, reject) => {
            const reader = new FileReader();  
            reader.onload = async () => {
                resolve(reader.result)
            }
            reader.readAsDataURL(file);
        });
    }

    async checkError( error: any ) {
        if (error?.status === 0 ) {
            return {
                ok: false,
                msg: 'Ha ocurrido un error inesperado',
                resp: 'No se pudo conectar con el servidor',
            };
        }
        if ( error?.status === 401 ) throw error;
        if (error?.error) {
            const serverError = error.error;
            const ret: ServiceResponse = {
                ok: false,
                msg: 'Ha ocurrido un error inesperado',
                resp: serverError,
            };
            return ret;
        }
        return {
            ok: false,
            msg: 'No se pudo conectar con el servidor',
            resp: 'Verifique su conexión a internet y vuelva a intentar'
        };
    }

    async postImage(id: number, tipo: string, file: any, nombre_campo: string = 'imagen', id_empresa?: number, nombre_empresa?: string ): Promise<ServiceResponse> {
        try {
            await this.updateToken();
            this.header['filters'] = JSON.stringify(await this.getAdicionalFilters( ));
            const formData = new FormData();
            formData.append('imagen', file, file.name);
            formData.append('nombre_campo', nombre_campo);
            if ( id_empresa ) {
                formData.append( 'id_empresa', id_empresa.toString() );
                formData.append( 'nombre_empresa', nombre_empresa );
            }

            const url = `${ environment.host }/file/${ tipo }/${ id }`;
            const resp = await lastValueFrom( this.http.post<any>(`${url}`, formData, { headers: this.header }) );
            return resp;
        } catch (error: any) {
            console.log(error);            
            return this.checkError( error );
        }
    }

}


export interface ServiceResponse {
    ok: boolean;
    msg: string;
    resp: any;
}